"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lang_js_1 = __importDefault(require("lang.js"));
var react_1 = __importStar(require("react"));
var Options_1 = __importDefault(require("./Options"));
var SemanticsContext = react_1.createContext([
    {
        translator: new lang_js_1.default({ locale: 'en' }),
    },
    function () { return ({}); },
]);
exports.SemanticsProvider = function (_a) {
    var children = _a.children, lang = _a.lang;
    var _b = react_1.useState({
        translator: new lang_js_1.default({ locale: 'en', messages: lang }),
    }), state = _b[0], setState = _b[1];
    return (react_1.default.createElement(SemanticsContext.Provider, { value: [state, setState] }, children));
};
exports.useSemantics = function () {
    var translator = react_1.useContext(SemanticsContext)[0].translator;
    var trans = function (key, replacements) {
        if (replacements === void 0) { replacements = {}; }
        return translator.get(key, replacements);
    };
    return { trans: trans, translator: translator, options: Options_1.default(trans) };
};
//# sourceMappingURL=SemanticsContext.js.map